import { render, staticRenderFns } from "./MinimalPopoverSelect.vue?vue&type=template&id=2fdc20eb&scoped=true"
import script from "./MinimalPopoverSelect.vue?vue&type=script&lang=js"
export * from "./MinimalPopoverSelect.vue?vue&type=script&lang=js"
import style0 from "./MinimalPopoverSelect.vue?vue&type=style&index=0&id=2fdc20eb&prod&scoped=true&lang=scss"
import style1 from "./MinimalPopoverSelect.vue?vue&type=style&index=1&id=2fdc20eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc20eb",
  null
  
)

export default component.exports